export default "__VITE_ASSET__0f01398b__"